export default [
  {
    id: 'email-hero-dark',
    name: 'Email Hero Dark',
    category: 'Email',
    thumbnail: '<div style="background:linear-gradient(135deg,#1a1a2e,#16213e);height:100%;display:flex;align-items:center;justify-content:center;color:#fff;"><div style="text-align:center;"><div style="font-size:4px;letter-spacing:2px;text-transform:uppercase;color:#a0a0ff;">INVITATION</div><div style="font-size:9px;font-weight:800;margin:2px 0;">Event Name</div><div style="font-size:4px;opacity:0.6;">Date · Venue</div></div></div>',
    html: `<table width="100%" cellpadding="0" cellspacing="0" border="0" style="background:linear-gradient(135deg,#1a1a2e,#16213e);"><tr><td align="center" style="padding:60px 20px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="text-align:center;">
    <p style="font-size:12px;letter-spacing:3px;text-transform:uppercase;color:#a0a0ff;margin:0 0 15px;">EXCLUSIVE INVITATION</p>
    <h1 style="font-size:36px;font-weight:800;color:#ffffff;margin:0 0 12px;line-height:1.2;">{{event_name}}</h1>
    <p style="font-size:16px;color:rgba(255,255,255,0.7);margin:0 0 8px;">{{event_date}} · {{venue}}</p>
    <p style="font-size:14px;color:rgba(255,255,255,0.5);margin:0;">Join 500+ industry leaders and innovators</p>
  </td></tr></table>
</td></tr></table>`,
  },
  {
    id: 'email-hero-gradient',
    name: 'Email Hero Gradient',
    category: 'Email',
    thumbnail: '<div style="background:linear-gradient(135deg,#667eea,#764ba2);height:100%;display:flex;align-items:center;justify-content:center;color:#fff;"><div style="text-align:center;"><div style="font-size:9px;font-weight:800;">Event Title</div><div style="font-size:4px;opacity:0.8;margin-top:2px;">Date & Location</div></div></div>',
    html: `<table width="100%" cellpadding="0" cellspacing="0" border="0" style="background:linear-gradient(135deg,#667eea,#764ba2);"><tr><td align="center" style="padding:50px 20px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="text-align:center;">
    <h1 style="font-size:34px;font-weight:800;color:#ffffff;margin:0 0 10px;line-height:1.2;">{{event_name}}</h1>
    <p style="font-size:16px;color:rgba(255,255,255,0.85);margin:0 0 6px;">{{event_date}}</p>
    <p style="font-size:14px;color:rgba(255,255,255,0.7);margin:0;">{{venue}}</p>
  </td></tr></table>
</td></tr></table>`,
  },
  {
    id: 'email-content-greeting',
    name: 'Email Greeting',
    category: 'Email',
    thumbnail: '<div style="background:#fff;height:100%;display:flex;align-items:center;justify-content:center;"><div style="padding:6px;"><div style="font-size:5px;color:#333;font-weight:600;">Dear Name,</div><div style="font-size:4px;color:#666;margin-top:2px;line-height:1.4;">You have been invited to attend this event...</div></div></div>',
    html: `<table width="100%" cellpadding="0" cellspacing="0" border="0" style="background:#ffffff;"><tr><td align="center" style="padding:0 20px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding:35px 20px;">
    <p style="font-size:16px;color:#333333;margin:0 0 15px;line-height:1.6;">Dear <strong>{{invitee_name}}</strong>,</p>
    <p style="font-size:15px;color:#555555;margin:0;line-height:1.7;">You have been personally selected to attend this premier event. This is your opportunity to connect with thought leaders, gain exclusive insights, and be part of something extraordinary.</p>
  </td></tr></table>
</td></tr></table>`,
  },
  {
    id: 'email-event-details',
    name: 'Email Event Details',
    category: 'Email',
    thumbnail: '<div style="background:#f8f9fa;height:100%;display:flex;align-items:center;justify-content:center;"><div style="padding:4px;"><div style="font-size:4px;color:#e74c3c;font-weight:700;">WHEN</div><div style="font-size:4px;color:#333;margin-bottom:3px;">Feb 15, 2026</div><div style="font-size:4px;color:#e74c3c;font-weight:700;">WHERE</div><div style="font-size:4px;color:#333;">Grand Ballroom</div></div></div>',
    html: `<table width="100%" cellpadding="0" cellspacing="0" border="0" style="background:#ffffff;"><tr><td align="center" style="padding:0 20px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding:10px 20px;">
    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background:#f8f9fa;border-radius:8px;"><tr><td style="padding:25px 30px;">
      <table width="100%" cellpadding="0" cellspacing="0" border="0">
        <tr>
          <td width="40" valign="top" style="padding-right:12px;"><div style="width:36px;height:36px;background:#fff0f0;border-radius:8px;text-align:center;line-height:36px;font-size:16px;">📅</div></td>
          <td valign="top" style="padding-bottom:18px;">
            <p style="font-size:11px;font-weight:700;color:#e74c3c;text-transform:uppercase;letter-spacing:1px;margin:0 0 4px;">When</p>
            <p style="font-size:15px;color:#333333;margin:0;font-weight:600;">{{event_date}}</p>
          </td>
        </tr>
        <tr>
          <td width="40" valign="top" style="padding-right:12px;"><div style="width:36px;height:36px;background:#f0fff0;border-radius:8px;text-align:center;line-height:36px;font-size:16px;">📍</div></td>
          <td valign="top">
            <p style="font-size:11px;font-weight:700;color:#e74c3c;text-transform:uppercase;letter-spacing:1px;margin:0 0 4px;">Where</p>
            <p style="font-size:15px;color:#333333;margin:0;font-weight:600;">{{venue}}</p>
          </td>
        </tr>
      </table>
    </td></tr></table>
  </td></tr></table>
</td></tr></table>`,
  },
  {
    id: 'email-cta-button',
    name: 'Email CTA Button',
    category: 'Email',
    thumbnail: '<div style="background:#fff;height:100%;display:flex;align-items:center;justify-content:center;"><div style="background:#e74c3c;color:#fff;font-size:5px;font-weight:700;padding:3px 12px;border-radius:3px;">RSVP NOW</div></div>',
    html: `<table width="100%" cellpadding="0" cellspacing="0" border="0" style="background:#ffffff;"><tr><td align="center" style="padding:0 20px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="padding:25px 20px;">
    <a href="{{rsvp_link}}" style="display:inline-block;padding:16px 50px;background:#e74c3c;color:#ffffff;border-radius:8px;text-decoration:none;font-size:16px;font-weight:700;letter-spacing:0.5px;">RSVP NOW</a>
    <p style="font-size:12px;color:#999999;margin:15px 0 0;line-height:1.5;">Limited seats available — respond by {{event_date}}</p>
  </td></tr></table>
</td></tr></table>`,
  },
  {
    id: 'email-two-column',
    name: 'Email Two Column',
    category: 'Email',
    thumbnail: '<div style="background:#fff;height:100%;display:flex;"><div style="width:50%;background:#f5f5f5;display:flex;align-items:center;justify-content:center;"><div style="font-size:5px;color:#333;">Left Column</div></div><div style="width:50%;background:#eee;display:flex;align-items:center;justify-content:center;"><div style="font-size:5px;color:#333;">Right Column</div></div></div>',
    html: `<table width="100%" cellpadding="0" cellspacing="0" border="0" style="background:#ffffff;"><tr><td align="center" style="padding:0 20px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0"><tr>
    <td width="50%" valign="top" style="padding:25px 15px 25px 20px;">
      <h3 style="font-size:18px;color:#333333;margin:0 0 10px;font-weight:700;">Left Column Title</h3>
      <p style="font-size:14px;color:#666666;margin:0;line-height:1.6;">Add your content here. This is a two-column layout for organizing information side by side.</p>
    </td>
    <td width="50%" valign="top" style="padding:25px 20px 25px 15px;">
      <h3 style="font-size:18px;color:#333333;margin:0 0 10px;font-weight:700;">Right Column Title</h3>
      <p style="font-size:14px;color:#666666;margin:0;line-height:1.6;">Add your content here. Perfect for comparing features, showing details, or creating visual balance.</p>
    </td>
  </tr></table>
</td></tr></table>`,
  },
  {
    id: 'email-footer',
    name: 'Email Footer',
    category: 'Email',
    thumbnail: '<div style="background:#333;height:100%;display:flex;align-items:center;justify-content:center;"><div style="text-align:center;"><div style="font-size:5px;color:#999;">Company Name</div><div style="font-size:3px;color:#666;margin-top:2px;">Unsubscribe | View Online</div></div></div>',
    html: `<table width="100%" cellpadding="0" cellspacing="0" border="0" style="background:#f8f9fa;"><tr><td align="center" style="padding:0 20px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="padding:30px 20px;text-align:center;">
    <p style="font-size:14px;color:#666666;margin:0 0 8px;font-weight:600;">{{company_name}}</p>
    <p style="font-size:12px;color:#999999;margin:0 0 12px;line-height:1.6;">You're receiving this because you were invited to {{event_name}}.</p>
    <p style="font-size:11px;color:#aaaaaa;margin:0;">
      <a href="#" style="color:#999999;text-decoration:underline;">Unsubscribe</a> · <a href="#" style="color:#999999;text-decoration:underline;">View in Browser</a>
    </p>
  </td></tr></table>
</td></tr></table>`,
  },
  {
    id: 'email-speaker-highlight',
    name: 'Email Speaker Highlight',
    category: 'Email',
    thumbnail: '<div style="background:#fff;height:100%;display:flex;align-items:center;justify-content:center;"><div style="text-align:center;"><div style="width:18px;height:18px;background:#ddd;border-radius:50%;margin:0 auto 3px;"></div><div style="font-size:5px;color:#333;font-weight:700;">Speaker Name</div><div style="font-size:3px;color:#666;">Title & Company</div></div></div>',
    html: `<table width="100%" cellpadding="0" cellspacing="0" border="0" style="background:#ffffff;"><tr><td align="center" style="padding:0 20px;">
  <table width="600" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding:30px 20px;">
    <h2 style="font-size:22px;color:#333333;margin:0 0 25px;text-align:center;font-weight:700;">Featured Speakers</h2>
    <table width="100%" cellpadding="0" cellspacing="0" border="0"><tr>
      <td width="33%" align="center" valign="top" style="padding:10px;">
        <div style="width:80px;height:80px;background:#e0e0e0;border-radius:50%;margin:0 auto 10px;"></div>
        <p style="font-size:14px;color:#333333;margin:0 0 3px;font-weight:700;">Speaker Name</p>
        <p style="font-size:12px;color:#888888;margin:0;">CEO, Company</p>
      </td>
      <td width="33%" align="center" valign="top" style="padding:10px;">
        <div style="width:80px;height:80px;background:#e0e0e0;border-radius:50%;margin:0 auto 10px;"></div>
        <p style="font-size:14px;color:#333333;margin:0 0 3px;font-weight:700;">Speaker Name</p>
        <p style="font-size:12px;color:#888888;margin:0;">CTO, Company</p>
      </td>
      <td width="33%" align="center" valign="top" style="padding:10px;">
        <div style="width:80px;height:80px;background:#e0e0e0;border-radius:50%;margin:0 auto 10px;"></div>
        <p style="font-size:14px;color:#333333;margin:0 0 3px;font-weight:700;">Speaker Name</p>
        <p style="font-size:12px;color:#888888;margin:0;">VP, Company</p>
      </td>
    </tr></table>
  </td></tr></table>
</td></tr></table>`,
  },
]
